import type { IWorkspaceInfo, IWorkspaceTeam } from 'src/@types/workspace-info';
import { QueryKey } from 'src/utils/react-query';

export const workspaceQueryKey = [QueryKey.WORKSPACE_INFO];

export type WorkspaceInfoQueryData = {
  workspace: IWorkspaceInfo;
  teams: IWorkspaceTeam[];
};
